import { Modal } from './Modal';
import { Button } from './Button';
import { useTranslation } from '../../i18n';

interface ConfirmDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  variant?: 'danger' | 'warning' | 'info';
  loading?: boolean;
}

export function ConfirmDialog({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText,
  cancelText,
  variant = 'danger',
  loading = false,
}: ConfirmDialogProps) {
  const { t } = useTranslation();

  const resolvedConfirmText = confirmText || t('common:actions.confirm');
  const resolvedCancelText = cancelText || t('common:actions.cancel');
  const confirmVariant = variant === 'info' ? 'primary' : 'danger';

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      size="sm"
      footer={
        <div className="flex flex-col-reverse sm:flex-row gap-2 sm:gap-3 sm:justify-end w-full">
          <Button
            variant="secondary"
            onClick={onClose}
            disabled={loading}
            className="w-full sm:w-auto"
          >
            {resolvedCancelText}
          </Button>
          <Button
            variant={confirmVariant}
            onClick={onConfirm}
            disabled={loading}
            className="w-full sm:w-auto"
          >
            {loading ? t('common:actions.loading') : resolvedConfirmText}
          </Button>
        </div>
      }
    >
      <p className="text-[13px] text-slate-700">{message}</p>
    </Modal>
  );
}

export default ConfirmDialog;
